// library dependancies
import $ from 'jquery';

import {
  clearSessionStorageProductNavigationOnSearch,
  clearSessionStorageProductNavigationIfNotPDP,
  setSessionStorageLastViewedProduct
} from 'src/utils/utils';

import newsletter from './components/newsletter';

$(() => {
  newsletter.init();
  clearSessionStorageProductNavigationOnSearch();
  clearSessionStorageProductNavigationIfNotPDP();
  setSessionStorageLastViewedProduct();
});
